export default __webpack_public_path__ + "static/media/P.b8157fa6.svg";